









































































































































































import Vue from 'vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import { UpdateStoreShippingAddressInput } from '@/types/generated/graphql'
import prefectures, { EntryType } from '@/packages/Prefectures'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import StorePicker from '@/components/molecules/StorePicker/StorePicker.vue'
import STORE_SHIPPING_ADDRESS_QUERY from '@/graphql/partner/storeShippingAddress.gql'
import UPDATE_STORE_SHIPPING_ADDRESS from '@/graphql/partner/updateStoreShippingAddress.gql'
import XTel from '@/components/atoms/Input/XTel.vue'

type Data = {
  partnerId: string
  id: string
  prefs: EntryType[]
  shippingAddressInput: UpdateStoreShippingAddressInput
  error: string
  loading: boolean
}

type Method = {
  onUpdate: () => void
  setAddress: (address: any) => void
}

type Computed = {
  prefOptions: OptionEntry<number>[]
}

export default Vue.extend<Data, Method, Computed, {}>({
  name: 'PartnerShippingAddressEdit',
  components: {
    XInput,
    XButton,
    XDropdown,
    XCard,
    XForm,
    XFormLabel,
    XZipInput,
    XTel,
    StorePicker,
  },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
      id: this.$route.params.id,
      shippingAddressInput: {
        id: '',
        storeId: '',
        name: '',
        destinationName: '',
        zipCode: '',
        prefId: -1,
        address1: '',
        address2: '',
        companyDepartment: '',
        phone: '',
      },
      prefs: prefectures(),
      error: '',
      loading: false,
    }
  },
  computed: {
    prefOptions(): OptionEntry<number>[] {
      const options = this.prefs.map((e) => {
        return { value: e.id, label: e.name }
      })
      options.splice(0, 0, { value: -1, label: '' })
      return options
    },
  },
  methods: {
    async onUpdate() {
      const input = this.shippingAddressInput
      await this.$apollo.mutate({
        mutation: UPDATE_STORE_SHIPPING_ADDRESS,
        variables: {
          input,
        },
      })
      await this.$router.push({
        name: 'PartnerShippingAddressList',
        params: { partnerId: this.partnerId },
      })
    },
    setAddress(address: any) {
      this.shippingAddressInput.prefId = address.prefId
      this.shippingAddressInput.address1 = address.locality + address.street
    },
  },
  apollo: {
    storeShippingAddress: {
      query: STORE_SHIPPING_ADDRESS_QUERY,
      variables(this: { partnerId: string; id: string }) {
        return {
          partnerId: this.partnerId,
          id: this.id,
        }
      },
      update({ storeShippingAddress }) {
        this.shippingAddressInput = {
          id: storeShippingAddress.storeShippingAddressId,
          storeId: storeShippingAddress.storeId,
          name: storeShippingAddress.name,
          destinationName: storeShippingAddress.destinationName,
          zipCode: storeShippingAddress.address.zipCode.fullCode,
          prefId: Number(storeShippingAddress.address.pref.id),
          address1: storeShippingAddress.address.address1,
          address2: storeShippingAddress.address.address2,
          companyDepartment: storeShippingAddress.companyDeparment,
          phone: storeShippingAddress.phone,
        }
      },
      fetchPolicy: 'network-only',
    },
  },
})
